import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Sparkles, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const scrollToPrecios = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-gradient-rose text-white overflow-hidden" data-id="element-57">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-20 pointer-events-none" data-id="element-58">
        <div className="absolute right-0 top-0 w-2/3 h-full bg-rose-600 blur-[150px] rounded-full transform translate-x-1/3" data-id="element-59" />
        <div className="absolute left-0 bottom-0 w-1/2 h-1/2 bg-brand-primary blur-[120px] rounded-full transform -translate-x-1/4" data-id="element-60" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 relative z-10" data-id="element-61">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-62">
          {/* Copy */}
          <div className="space-y-8 text-center lg:text-left" data-id="element-63">
            <div className="inline-flex items-center space-x-2 bg-rose-500/20 border border-rose-400/30 rounded-full px-4 py-1.5 text-rose-200 text-xs sm:text-sm font-bold tracking-wider uppercase" data-id="element-64">
              <Sparkles className="w-4 h-4 text-rose-300" data-id="element-65" />
              <span data-id="element-66">El método que está revolucionando Estados Unidos</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-medium italic tracking-tight leading-tight" data-id="element-67">
              ESCAPE 9-A-5: <br data-id="element-68" />
              <span className="not-italic font-bold text-white" data-id="element-69">
                El Método para Mujeres
              </span>{' '}
              que Está{' '}
              <span className="text-brand-secondary" data-id="element-70">
                Revolucionando Todo Estados Unidos
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-rose-100 max-w-2xl mx-auto lg:mx-0 font-light leading-relaxed" data-id="element-71">
              Diseñado exclusivamente para mujeres latinas que merecen la
              libertad que siempre quisieron tener. Sin jefes. Sin horarios.
              Desde la comodidad de tu hogar.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-72">
              <Button size="lg" onClick={scrollToPrecios} className="w-full sm:w-auto animate-pulse-rose shadow-rose-500/40" data-id="element-73">
                QUIERO MI LIBERTAD — SOLO $6.36
                <ArrowRight className="ml-2 h-5 w-5 shrink-0" data-id="element-74" />
              </Button>
            </div>

            <p className="text-xs text-rose-300 uppercase tracking-widest font-semibold text-center lg:text-left" data-id="element-75">
              *Oferta exclusiva por tiempo limitado
            </p>

            <div className="pt-6 border-t border-rose-900/50 grid grid-cols-2 gap-y-3 gap-x-6 text-sm text-rose-100 max-w-md mx-auto lg:mx-0" data-id="element-76">
              <div className="flex items-center" data-id="element-77">
                <CheckCircle2 className="w-5 h-5 text-brand-secondary mr-2" data-id="element-78" />
                <span data-id="element-79">Solo para Mujeres</span>
              </div>
              <div className="flex items-center" data-id="element-80">
                <CheckCircle2 className="w-5 h-5 text-brand-secondary mr-2" data-id="element-81" />
                <span data-id="element-82">En Español</span>
              </div>
              <div className="flex items-center" data-id="element-83">
                <CheckCircle2 className="w-5 h-5 text-brand-secondary mr-2" data-id="element-84" />
                <span data-id="element-85">100% Desde Casa</span>
              </div>
              <div className="flex items-center" data-id="element-86">
                <CheckCircle2 className="w-5 h-5 text-brand-secondary mr-2" data-id="element-87" />
                <span data-id="element-88">Sin Experiencia</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative mx-auto lg:ml-auto w-full max-w-md lg:max-w-full" data-id="element-89">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-rose-900/50 bg-brand-dark transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-90">
              <img src="https://cdn.magicpatterns.com/uploads/9NPeY4YW4uFPCcYbwGT6TW/heylloyd-image-1771653562743.png" alt="Mujer latina exitosa trabajando desde casa" className="w-full h-auto object-cover opacity-90 hover:opacity-100 transition-opacity" data-id="element-91" />

              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-md p-4 rounded-2xl shadow-xl border border-rose-100" data-id="element-92">
                <div className="flex items-center justify-between" data-id="element-93">
                  <div className="flex items-center gap-3" data-id="element-94">
                    <div className="flex -space-x-2" data-id="element-95">
                      <div className="w-8 h-8 rounded-full bg-rose-200 border-2 border-white flex items-center justify-center text-xs font-bold text-rose-700" data-id="element-96">
                        A
                      </div>
                      <div className="w-8 h-8 rounded-full bg-rose-300 border-2 border-white flex items-center justify-center text-xs font-bold text-rose-800" data-id="element-97">
                        M
                      </div>
                      <div className="w-8 h-8 rounded-full bg-rose-400 border-2 border-white flex items-center justify-center text-xs font-bold text-white" data-id="element-98">
                        S
                      </div>
                    </div>
                    <div data-id="element-99">
                      <p className="text-xs text-rose-500 uppercase font-bold tracking-wider" data-id="element-100">
                        Comunidad
                      </p>
                      <p className="text-brand-dark font-bold text-sm" data-id="element-101">
                        🔥 Miles de mujeres unidas
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-brand-secondary rounded-full blur-2xl opacity-40 animate-pulse" data-id="element-102"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-brand-primary rounded-full blur-3xl opacity-30" data-id="element-103"></div>
          </div>
        </div>
      </div>
    </section>;
}